import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FeedAdviceOverviewResolver } from './resolvers/feed-advice-overview.resolver';
import { GetFeedAdviceByIdResolver } from './resolvers/get-feed-advice-by-id.resolver';
import { FeedAdviceService } from './services/feed-advice.service';
import { FeedAdviceEffects } from './store/feed-advice.effects';
import * as feedAdviceReducer from './store/feed-advice.reducer';

export function provideFeedAdviceFeature() {
  return makeEnvironmentProviders([
    provideState('feedAdviceModule', feedAdviceReducer.reducer),
    provideEffects(FeedAdviceEffects),
    FeedAdviceService,
    FeedAdviceOverviewResolver,
    GetFeedAdviceByIdResolver,
  ]);
}
